import * as React from 'react'
import clsx from 'clsx'

import { assetUrl } from 'utils/url'

export interface NotificationProps
  extends React.HTMLAttributes<HTMLDivElement> {
  color?: 'gray' | 'orange-10'
  icon?: 'lightbulb' | 'info' | ''
}

const variants = {
  gray: 'bg-[#F3F5F5] text-[#52575C]',
  'orange-10': 'bg-orange-10 text-default',
}

export const Alert = React.forwardRef<HTMLDivElement, NotificationProps>(
  ({ className, color, icon = 'lightbulb', children, ...props }, ref) => {
    const classes = clsx(
      'py-3 px-4 rounded-lg flex',
      className,
      variants[color]
    )
    return (
      <div className={classes} ref={ref} {...props}>
        {!!icon && (
          <img
            src={assetUrl(`/icon/${icon}.svg`)}
            alt=""
            className="self-start mt-1 mr-3"
          />
        )}
        <div>{children}</div>
      </div>
    )
  }
)

Alert.displayName = 'Alert'

export default Alert
